module.exports = __webpack_public_path__ + "static/media/Walking.79ae0b71.svg";